import React from 'react';

import { formatPhone } from '../../utils/formatPhone';

type PhoneInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'onChange' | 'value' | 'type'
> & {
  value: string;
  onChange: (formatted: string) => void;
};

const PhoneInput = React.forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ value, onChange, ...rest }, ref) => (
    <input
      {...rest}
      ref={ref}
      type="tel"
      inputMode="tel"
      // Format on display too (idempotent), so existing/loaded raw numbers like
      // "3057676463" show as "(305) 767-6463", not just newly-typed input.
      value={formatPhone(value)}
      onChange={(e) => onChange(formatPhone(e.target.value))}
    />
  )
);
PhoneInput.displayName = 'PhoneInput';

export default PhoneInput;
